import React from 'react';

export const useRepeater = (repeatInterval: number, accordingToClock = false): number => {
  const [repeater, setRepeater] = React.useState(0);

  React.useEffect(() => {
    let interval: number;
    let timeout: number;
    const now = new Date();
    const delay =
      repeatInterval - ((now.getSeconds() * 1000 + now.getMilliseconds()) % repeatInterval);

    const start = () => {
      setRepeater((prev) => prev + 1);
      interval = window.setInterval(() => setRepeater((prev) => prev + 1), repeatInterval);
    };

    // delay execution until it's an even interval
    if (accordingToClock) {
      timeout = window.setTimeout(start, delay);
    } else {
      start();
    }

    return () => {
      // clear interval and timeout
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [repeatInterval, accordingToClock]);

  return repeater;
};

export default useRepeater;
